export const DATE_FROM_TEXTS = {
  fieldLabel: 'Дата вылета',
  valuePrefix: 'с ',
  rangeJoin: ' по ',
  flexSign: '±',
  mobileRangeJoin: ' – ',
} as const;

export const STAY_DATES_TEXTS = {
  fieldLabel: 'Даты проживания',
  pickCheckOut: 'выберите дату выезда',
  exactDates: 'Точные даты',
} as const;
